export default __webpack_public_path__ + "5ed6ae63047821a1bead60df847d5345.svg";